import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { usePermissionContext } from '../../contexts/PermissionContext'
import { Layout } from './Layout'
import { LoadingSpinner } from '../ui/LoadingSpinner'

export const RegularUserLayout: React.FC = () => {
  const { isAuthenticated } = useAuth()
  const { isPlatformAdmin } = usePermissionContext()
  const navigate = useNavigate()

  React.useEffect(() => {
    if (isAuthenticated && isPlatformAdmin) {
      navigate('/app/admin', { replace: true })
    }
  }, [isPlatformAdmin, isAuthenticated, navigate])

  if (isAuthenticated && isPlatformAdmin) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  return <Layout />
}
